import { gql } from "@apollo/client"
import craftApolloClient from "./api/apollo"

import _ from 'lodash'

import Head from "next/head"

import { LenisScroller } from '../fuselage/animation/lenis-scroller'
import { Reveal } from '../fuselage/animation/reveal'

import { QuerySEO } from "../graphql/queries"
import handleSeomaticMeta from "../lib/seomatic"

import { HeaderShim } from "../fuselage/global/header/header"
import { HeroBrandOnSite } from "../fuselage/blocks/hero-brand-on-site/hero-brand-on-site"
import { ImpactFiguresGrid, ImpactFigures, ImpactFigure, ImpactFigureSpacer } from "../fuselage/blocks/impact-figures/impact-figures"








export default function Homepage ({ seomatic }) {

    return (
        <div style={{ width: `100%`, overflow: `hidden` }}>
            <Head>
                { handleSeomaticMeta( seomatic ) }
            </Head>

            <HeaderShim />


            <HeroBrandOnSite />


            <ImpactFiguresGrid>
                <div className="fs-0 fw-600 c-white lh-1"><Reveal>FHS&nbsp;Africa 2025</Reveal> <Reveal delay={0.1}>in numbers</Reveal></div>

                <ImpactFigures>      
                    <ImpactFigure value="500" suffix="+" label="delegates" />
                    <ImpactFigure value="100" suffix="+" label="Investors" />
                    <ImpactFigureSpacer/>
                    <ImpactFigure value="248" prefix="$" suffix="M" label="AUM" />
                    <ImpactFigure value="100" suffix="+" label="speakers" />
                    <ImpactFigure value="35" suffix="%" label="International Attendees" />
                </ImpactFigures>
            </ImpactFiguresGrid>

            <LenisScroller />
        </div>
    )
}



export async function getStaticProps({ preview, previewData }) {

    const data = await craftApolloClient( preview, previewData ).query({
        query: gql`
			query Homepage {
				entry(site: "${process.env.SITE_HANDLE}", id: "15757") {
					... on ${process.env.SITE_HANDLE}Homepage_${process.env.SITE_HANDLE}Homepage_Entry {
						${QuerySEO}
					}
				}
			}
        `
    })
    const pageData = data
    


    return { 
		props: { 
            seomatic: pageData.data.entry.seomatic,
		}
	}
}
